<template>
  <div>
    <el-menu
      default-active="1-4-1"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      :collapse-transition="true"
    >
      <h3>{{ isCollapse ? "AMH" : "AMH后台管理系统" }}</h3>

      <el-menu-item
        @click="clickMenu(item)"
        v-for="item in noChildren"
        :key="item.name"
        :index="item.name"
      >
        <i :class="`el-icon-${item.icon}`"></i>
        <span slot="title">{{ item.label }}</span>
      </el-menu-item>

      <!-- <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">用户列表</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1">选项1</el-menu-item>
          <el-menu-item index="1-2">选项2</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  name: "MainAside",
  data() {
    return {

    };
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    clickMenu(item) {
      this.$store.commit('selectMenu',item)
      this.$router.push(
        item.path
      )
    },
  },
  computed: {
    noChildren() {
      return this.menuData.filter((item) => !item.children);
    },
    hasChildren() {
      return this.menuData.filter((item) => item.children);
    },
    menuData(){
      return JSON.parse(Cookie.get('menu')) || this.$store.state.tab.menu
    },
    isCollapse(){
      return this.$store.state.tab.isCollapse
    }
  },
};
</script>

<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu {
  height: 100vh;
  border-right: none;
  h3 {
    height: 60px;
    line-height: 60px;
    color: #fff;
    text-align: center;
    white-space: nowrap;
  }
}
</style>
